import type { JSX } from "react";
import PlusMinus from "../../../shared/components/icons/PlusMinus";
import RenderMark from "../../../shared/components/RenderMark";
import useScrollIntoView from "../../../shared/hooks/useScrollIntoView";
import t from "../../../shared/translations";
import { Accordion, AccordionHead } from "../stylings/accordion";
import type { IAccordion } from "./Theory";

interface IProps {
    content: string;
    open: boolean;
    toggle: (acc: IAccordion) => void;
}

function TLB({ content, open, toggle }: IProps): JSX.Element {
    const ref = useScrollIntoView<HTMLDivElement>(open);
    return (
        <Accordion ref={ref}>
            <AccordionHead onClick={() => toggle("TLB")}>
                <h2>{t("player.team-scan-theory.heading-tlb")}</h2>
                <PlusMinus open={open} />
            </AccordionHead>
            {open && <RenderMark content={content} unsafe />}
        </Accordion>
    );
}

export default TLB;
